// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-checkbox {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-top: 10px;
}

.custom-checkbox:checked {
    background-color: #007bff;
    border-color: #007bff;
}

.custom-checkbox:checked::before {
    content: '✔';
    display: block;
    text-align: center;
    color: white;
    font-size: 14px;
    line-height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/programas/config-avanzada/analisis-alimentacion/registro-alimentos/registro-alimentos.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".custom-checkbox {\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    margin-top: 10px;\n}\n\n.custom-checkbox:checked {\n    background-color: #007bff;\n    border-color: #007bff;\n}\n\n.custom-checkbox:checked::before {\n    content: '✔';\n    display: block;\n    text-align: center;\n    color: white;\n    font-size: 14px;\n    line-height: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
